import { enqueueSnackbar } from "notistack";
import BaseSnackbar from "./base.component";

export default function SuccessSnackbar(title?: string) {
  return enqueueSnackbar(title || "항목 추가 완료", {
    content: (key, message) => (
      <BaseSnackbar key={key} message={message} severity="success" />
    ),
  });
}
